import React, {useEffect} from 'react';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import {MoreVert} from "@mui/icons-material";
import {ThemeProvider, createTheme} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
    Stack
} from "@mui/material";
import {Link, NavLink, Outlet} from "react-router-dom";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

const pages = [
    { label:'Standings', page:'standings' },
    { label:'Policies', page:'policies' },
    { label:'Locations', page:'locations' },
    { label:'About Us', page:'aboutUs' },
    { label:'Past Results', page:'pastResults' },
    { label:'Modified', page:'modified' }
];

function App() {

    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    let logo =
        <Stack direction='row' alignItems='center'>
            <Box sx={{ paddingRight: { xs: '5px', md: '15px'}, height: { xs: '20px', md: '30px'} }}>
                <img src='wnycaaBall.png' style={{ height: '100%' }}/>
            </Box>
            <Typography
                variant="h3"
                noWrap
                sx={{
                    fontFamily: 'monospace',
                    fontWeight: 600,
                    fontSize: { xs: '2rem', md: '3rem' },
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                }}>WNYCAA</Typography>
        </Stack>

    return (

        <ThemeProvider theme={darkTheme}>
            <CssBaseline/>
            <div className="App">
                <AppBar position="static">
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}} id="mainBar">
                                <Stack direction='row' alignItems='center' justifyContent='flex-start'
                                       sx={{cursor: "pointer"}}>
                                    <Link to="/">{logo}</Link>
                                </Stack>
                                <Box sx={{
                                    flexGrow: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: {xs: 'none', md: 'flex'}
                                }}>
                                    <Stack direction="row" alignItems="center" spacing={3}>
                                        {pages.map((page) => (
                                            <NavLink to={page.page}>{page.label}</NavLink>
                                        ))}
                                    </Stack>
                                </Box>
                            </Box>
                            <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenNavMenu}
                                    color="inherit"
                                >
                                    <MenuIcon/>
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorElNav}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    open={Boolean(anchorElNav)}
                                    onClose={handleCloseNavMenu}
                                    sx={{
                                        display: {xs: 'block', md: 'none'},
                                    }}
                                >
                                    {pages.map((page) => (
                                        <MenuItem key={page.page} onClick={() => handleCloseNavMenu()}>
                                            <NavLink to={page.page}>{page.label}</NavLink>
                                        </MenuItem>
                                    ))}
                                </Menu>
                                <Stack flexGrow='1' direction='row' alignItems='center' justifyContent='center'>
                                    <Link to="/">{logo}</Link>
                                </Stack>
                            </Box>

                            <Box sx={{
                                flexGrow: 0,
                                display: 'flex',
                                justifyContent: "flex-end",
                                flexBasis: {xs: 'auto', md: '200px'}
                            }}>&nbsp;
                            </Box>
                        </Toolbar>
                    </Container>
                </AppBar>
                <Stack direction='column' alignItems='center' sx={{ width: "100%", height: "100%" }}>
                    <Outlet/>
                </Stack>
            </div>
        </ThemeProvider>
    );
}

export default App;
